import React, { Component } from 'react';
import { Card, ModalBody, ModalNext, withModalContext } from "@jutro/components";
import { MetadataContent } from '@jutro/uiconfig';
import metadata from './TrainingCoursePopover.metadata.json5';
import styles from './TrainingCoursePopover.module.scss';

class TrainingCoursePopover extends Component {
    state = {};

    handleDismiss = (evt) => {
        // eslint-disable-next-line react/prop-types
        const { onResolve } = this.props;
        evt.stopPropagation();
        onResolve();
    }

    render() {
        // eslint-disable-next-line react/prop-types

        const overrides = {

            cancel: {
                content: 'Got It',
                visible: 'true',

            },

        };
        const resolvers = {
            resolveCallbackMap: {
                onCancel: this.handleDismiss,

            },
            resolveClassNameMap: styles
        };
        return (
            <ModalNext isOpen={this.props.isOpen}>
                <ModalBody>
                    <Card id="standardizedPanel" className={styles.alfaAddStdModal}>
                        <MetadataContent
                            uiProps={metadata.componentContent}
                            overrideProps={overrides}
                            {...resolvers}
                        />
                    </Card>
                </ModalBody>
            </ModalNext>
        );
    }
}

export default withModalContext(TrainingCoursePopover);
